const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[\d\s+().-]+$/;

export const isValidEmail = (email: string): boolean => EMAIL_REGEX.test(email.trim());

// allows digits and formatting chars (spaces, + - . ()) and requires at least 7 digits
export const isValidPhone = (phone: string): boolean =>
	PHONE_REGEX.test(phone.trim()) && phone.trim().replace(/\D/g, "").length >= 7;
